/* global bcjData */

const loadMore = (() => {
  const { ajaxUrl, nonce } = bcjData;

  const sections = document.querySelectorAll('.js-load-more');

  if (!sections.length) {
    return;
  }

  async function ajaxRequest(params) {
    const response = await fetch(`${ajaxUrl}`, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'Cache-Control': 'no-cache',
      },
      body: new URLSearchParams({
        nonce,
        action: 'bcj_load_more',
        ...params,
      }),
    });

    const result = await response.json();

    return result;
  }

  sections.forEach((section) => {
    const content = section.querySelector('.js-load-more-content');
    const button = section.querySelector('.js-load-more-button');
    let loading = false;
    let page = 1;

    button.addEventListener('click', () => {
      if (loading) {
        return;
      }

      const {
        postType,
        queryType,
        offset,
        postsPerPage,
        taxonomy,
        taxonomyTerms,
        search,
        isSearch,
        postNotIn,
        buttonLabel,
        buttonLoadingLabel,
      } = content.dataset;

      loading = true;
      button.innerText = buttonLoadingLabel;

      ajaxRequest({
        page,
        postType,
        queryType,
        offset,
        postsPerPage,
        taxonomy,
        taxonomyTerms,
        search,
        isSearch,
        postNotIn,
      }).then((result) => {
        const { success, data } = result;

        if (success) {
          page += 1;
          button.innerText = buttonLabel;

          // content.innerHTML += data.html;
          content.insertAdjacentHTML('beforeend', data.html);

          if (!data.more) {
            button.parentElement.remove();
          }
        } else {
          button.innerText = data.error;
          button.style.color = '#d00';
        }

        loading = false;
      });
    });
  });
})();

export default loadMore;
